<div class="pb-3">
  <a [routerLink]="['/operator/catalog']" class="return-link">
    <i class="pi pi-angle-left angle-left-icon"></i>
    <span class="pl-1" style="vertical-align: bottom"> {{'catalog.returnToCatalog' | translate}} </span>
  </a>
</div>

<div class="title">
  <i class="pi pi-file bg-icon"></i>
  <span class="pl-2" style="font-size: 1.2rem">{{ product?.title | translate }}</span>
</div>

<div class="card-wrapper">
  <div class="top grid">
    <div class="lg:col-3 md:col-4 sm:col-4">
      <p-select
        [disabled]="true"
        [options]="userChannels"
        class="w-full"
        [(ngModel)]="selectedChannel">
        <ng-template let-selectedItem pTemplate="selectedItem">
          @if (selectedItem) {
            <p class="inline line-height-1">{{ "global.distributionChannel" | translate }} -</p>
            <p class="inline font-bold line-height-1">
              {{ selectedItem.channelName }}
            </p>
          }
        </ng-template>
        <ng-template let-item pTemplate="item">
          <p class="inline font-bold line-height-1">
            {{ item.channelName }}
          </p>
        </ng-template>
      </p-select>
    </div>
    <div [class]="locales?.length > 1 ? 'lg:col-7 md:col-4 sm:col-4  text-right' : 'lg:col-9 md:col-4 sm:col-4  text-right'">
     <!--  <p-button [outlined]="true" styleClass="vertical-align-middle" (click)="openHistoryDialog()">
        <i class="pi pi-clock"></i>
        <span class="pl-2">{{'global.history' | translate}}</span>
      </p-button> -->
    </div>
  </div>

  <div class="bottom">
    <div class="left">
      <div class="subtitle flex">
        <div class="flex-1">
          <span>
            {{ "detailProduct.masterProduct" | translate }}
          </span>
        </div>
        <div>
          @if (product) {
            <p-tag
              [severity]="getSeverityForPublicationStatus(product.publicationStatus, product)"
              value="{{ product.publicationStatus | translate }}"
              [tp]="tpl">
              <ng-template #tpl>
                <div class="flex align-items-center text-justify p-2" style="font-size: 11px">
                  {{ product.publicationStatus + "Message" | translate }}
                </div>
              </ng-template>
            </p-tag>
          }
        </div>
      </div>
      <div
        [ngClass]="{ 'selected-item': selectedProductHighlight === product?.productId }"
        (click)="handleProductClick(product)"
        class="master-product shadow-2">
        <div class="flex">
          <div style="margin: 8px 0">
            <img
              [src]="product?.images[0].url"
              alt="Main product"
              style="width: 60px; height: 60px; object-fit: cover" />
          </div>
          <div class= "pl-3" style="width: 100% !important;">
            <p-timeline [value]="productStatus" layout="horizontal">
              <ng-template pTemplate="marker" let-event>
                <p-tag
                  [value]="event.step"
                  [severity]="event.severity"
                  [class]="'step-tag'"
                  [styleClass]="event.severity"></p-tag>
              </ng-template>
              <ng-template pTemplate="content" let-event>
                <div [tp]="tpl" [tpPlacement]="'bottom'" [tpPopperWidth]="'350px'" style="font-size: 0.8rem">
                  <div class="timeline-content">{{ event.statusCode | translate }}</div>
                  @if(event.statusText === 'SYNCHRONIZED' || event.statusText === 'NOT_SYNCHRONIZED'){
                    <div
                      [style.color]="event.color"
                      class="font-semibold timeline-content"
                      [class]="'text-color-' + getSeverityForPublicationStatus(event.statusText, product)">
                      {{ event.statusText.trim() | translate }}
                    </div>
                  }@else {
                    <div
                      [style.color]="event.color"
                      class="font-semibold timeline-content"
                      [class]="'text-color-' + getSeverity(event.statusText)">
                      {{ event.statusText.trim() | translate }}
                    </div>
                  }
                  
                  @if (event.statusDate) {
                    <div class="timeline-content">{{ event.statusDate }}</div>
                  }
                </div>
                <ng-template #tpl>
                  <div class="flex align-items-center text-justify p-2 timeline-content">
                    {{ event.statusDescription | translate }}
                  </div>
                </ng-template>
              </ng-template>
            </p-timeline>
          </div>
        </div>
      </div>
    </div>

    <p-divider layout="vertical" class="divider" />

    <div class="right w-full">
      <div class="subtitle subtitle-right">
        <span> {{'detailProduct.productSheet' | translate}} </span>
      </div>
      <div class="carousel">
        <p-carousel
          class="custom-carousel"
          [value]="sellerProducts"
          [numVisible]="3"
          [numScroll]="1"
          [circular]="false">
          <ng-template let-item pTemplate="item">
            <div class="overlay shadow-1">
              <div
                class="product-card"
                (click)="handleProductClick(item, true)"
                [ngClass]="{ 'selected-item': item.productId === selectedProductHighlight }">
                <div class="product-card-left">
                  <img
                    [src]="item?.image.trim()"
                    style="width: 60px; height: 60px; object-fit: cover"
                    alt="Main product" />
                </div>
                <div class="product-card-right">
                  <div class="product-card-seller">
                    <i class="pi pi-shop"></i>
                    <div>{{ item.seller }}</div>
                  </div>
                  <p-tag
                    value="{{ item.status.trim() | translate }}"
                    [severity]="getSeverity(item.status?.trim())"></p-tag>
                  <div>
                    <span>{{'products.createdAt' | translate}} : {{item?.creationDate}}</span>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </p-carousel>
      </div>
    </div>
  </div>
</div>

@if (messages.length > 0) {
  @for(message of messages; track $index){
    <p-message [severity]="getMessageSeverity(message.severity)">
        <div class="ml-2">
          <div class="font-semibold">{{ message.severity | translate }} - {{ message.summary | translate }}</div>
          <div>
             @if(isArray(message.detail) ) {
                @for(msg of getDetailArray(message.detail); track $index) {
                  @if(msg.length > 250) {
                    <div class="message-item" [ngClass]="expandedStates[$index] ? 'message-expanded' : 'message-collapsed'">
                      <div class="message-text">
                        {{ expandedStates[$index] ? msg : (msg | slice:0:250) + '...' }}
                      </div>
                      <div class="expand-button mt-1">
                        <p-button 
                          [icon]="expandedStates[$index] ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
                          [label]="expandedStates[$index] ? 'Réduire' : 'Voir plus'"
                          size="small"
                          [text]="true"
                          (onClick)="toggleExpand($index)">
                        </p-button>
                      </div>
                    </div>
                  } @else {
                    <div class="message-short">
                      <div class="message-text">{{ msg }}</div>
                    </div>
                  }
                }
            } @else {
              <span>{{ message.detail }}</span> 
            }
          </div>
        </div>
    </p-message>
  }
}
<p-message class="messages" severity="info" [closable]="false">
    <div class="ml-2">
      <div class="mb-3">
        <span class=" custom-link" [innerHTML]="'products.productLifeCycleDetail' | translate"></span>
        <a class="custom-link underline pl-1" target="_blank" [href]="getTutoLink()">{{
          'products.tutoLink' | translate
          }}</a>
      </div>
     
      <span class="font-semibold">{{'products.moreInfo' | translate}} 
        <button class="document-link" type="button"  (click)="onDownload()">
          <i class="pi pi-download mr-2"></i>
          {{'products.downloadDoc' | translate}}
        </button>
      </span>
      </div>
</p-message>
<div class="product-attribute-container mt-3">
  <p-card class="shadow-2">
    @if (selectedProduct) {
      <app-product-attributes
        #productAttributes
        [product]="selectedProduct"
        [disabled]="true"
        [isMasterProduct]="!isSellerProduct"
        [operator]="true"
        [categories]="categories"
        (update)="refreshProduct($event)">
      </app-product-attributes>
    }
  </p-card>
</div>
